import React from 'react';
import { motion } from 'framer-motion';
export function LifecycleArchitecture() {
  const nodes = [{
    title: 'Early Development',
    desc: 'Regulation, cooperation, foundational reasoning'
  }, {
    title: 'Education',
    desc: 'Logic, literacy, planning, media resilience'
  }, {
    title: 'Workforce & Civic',
    desc: 'Readiness, mobility, self-direction, contribution'
  }, {
    title: 'Civil Service',
    desc: 'Integrity, systems thinking, judgment under pressure'
  }, {
    title: 'Executive Leadership',
    desc: 'Crisis reasoning, consequence modeling, governance stability'
  }];
  return <section className="py-24 lg:py-32 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-847" data-mp="1bjv2tefx3h60">
      <div className="text-center mb-20" data-id="element-848" data-mp="1blo92smmbzdh">
        <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em] mb-4 block" data-id="element-849" data-mp="30zui7da4q2u3">
          Lifecycle Model
        </span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-ink-dark" data-id="element-850" data-mp="35vrw7cxx6x3p">
          Designed to scale from childhood to high office
        </h2>
      </div>

      {/* Desktop Timeline */}
      <div className="hidden lg:block relative mb-16 px-4" data-id="element-851" data-mp="qus1gkm8ni51">
        {/* Base Line */}
        <div className="absolute top-[22px] left-8 right-8 h-0.5 bg-line" data-id="element-852" data-mp="15nlhq89c42ar"></div>
        {/* Gradient Progress Line */}
        <div className="absolute top-[22px] left-8 right-8 h-0.5 bg-gradient-to-r from-teal via-navy-light to-navy opacity-60" data-id="element-853" data-mp="cwtu3z6c4lz1"></div>

        <div className="flex justify-between relative" data-id="element-854" data-mp="7ys9vax6aglz">
          {nodes.map((node, index) => <motion.div key={node.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="flex flex-col items-center w-48 text-center relative" data-id="element-855" data-mp="lykvwsxr88nm" data-mpi={index}>
              {/* Node Circle */}
              <div className={`w-12 h-12 rounded-full bg-white border-4 z-10 flex items-center justify-center mb-6 shadow-sm transition-transform hover:scale-110 ${index === nodes.length - 1 ? 'border-navy' : 'border-surface-muted shadow-inner'}`} data-id="element-856" data-mp="zy3qd37rnffv">
                <div className={`w-3 h-3 rounded-full ${index === nodes.length - 1 ? 'bg-navy' : 'bg-teal'}`} data-id="element-857" data-mp="c8j5ges1y83y"></div>
              </div>

              <h3 className="text-lg font-heading font-bold text-ink-dark mb-2" data-id="element-858" data-mp="g89tiaq72a4s">
                {node.title}
              </h3>
              <p className="text-sm text-ink-muted leading-relaxed" data-id="element-859" data-mp="3kouebf5xddnn">
                {node.desc}
              </p>
            </motion.div>)}
        </div>
      </div>

      {/* Mobile Timeline */}
      <div className="lg:hidden relative pl-8 py-4 space-y-12 mb-12" data-id="element-860" data-mp="3h76ry03o39mi">
        <div className="absolute top-4 bottom-4 left-[23px] w-0.5 bg-gradient-to-b from-teal via-navy-light to-navy opacity-60" data-id="element-861" data-mp="3h4as2689eavf"></div>

        {nodes.map((node, index) => <motion.div key={node.title} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="relative pl-8" data-id="element-862" data-mp="3845lfyaw3gib" data-mpi={index}>
            <div className={`absolute left-[-24px] top-0 w-10 h-10 rounded-full bg-white border-4 z-10 flex items-center justify-center ${index === nodes.length - 1 ? 'border-navy' : 'border-surface-muted'}`} data-id="element-863" data-mp="2kgo1goxv9mpw">
              <div className={`w-2.5 h-2.5 rounded-full ${index === nodes.length - 1 ? 'bg-navy' : 'bg-teal'}`} data-id="element-864" data-mp="2ajjbee0wh73t"></div>
            </div>

            <h3 className="text-lg font-heading font-bold text-ink-dark mb-1 pt-1" data-id="element-865" data-mp="jeogbcb93xgz">
              {node.title}
            </h3>
            <p className="text-sm text-ink-muted leading-relaxed" data-id="element-866" data-mp="4oh7zpeyjuu0">
              {node.desc}
            </p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      delay: 0.4
    }} className="text-center max-w-3xl mx-auto" data-id="element-867" data-mp="3rtzuqdw8o0i7">
        <p className="text-lg font-medium text-navy-light italic border-t border-line pt-8" data-id="element-868" data-mp="3mudh43ci0i8v">
          The lower the level of power, the more developmental the system.{' '}
          <br className="hidden md:block" data-id="element-869" data-mp="1l3iht1j320xe" />
          The higher the level of power, the more rigorous the standard.
        </p>
      </motion.div>
    </section>;
}